import bundleFeature from '../../utils/bundleFeature'

import { WebinarSidebarComponent } from './components/WebinarSidebarComponent'
import sagas from './sagas'
import actions from './actions'
import reducer from './reducer'

export default bundleFeature({
  Component: WebinarSidebarComponent,
  actions,
  sagas,
  reducer,
})
